import Button from '@carvana/ds-button';
import PlayButtonFilled from '@carvana/ds-icons/PlayFilledCvna';
import cx from 'classnames';

export type VideoPosterProps = {
  id: string;
  youtubeId: string | null;
  image: string;
  className?: string;
  description?: string;
};

export default function VideoPoster({
  youtubeId,
  image,
  isActive = false,
  description
}: VideoPosterProps & { isActive: boolean }) {
  return (
    <div className="flex w-full flex-col items-center justify-center">
      <div className="relative w-full">
        <img
          src={image}
          alt={description ?? 'Video thumbnail'}
          className="w-full rounded-lg"
        />

        {youtubeId && (
          <Button
            icon={true}
            size="lg"
            variant={'primaryInverted'}
            className={cx(
              'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
              isActive ? 'opacity-100' : 'opacity-0',
              'duration-800 transition-opacity'
            )}
            aria-label="Play Video"
            data-analytics-id={null}
          >
            <PlayButtonFilled />
          </Button>
        )}
      </div>

      {isActive && (
        <div className="flex w-full items-center justify-center">
          <div className="flex w-full flex-col items-start gap-4 pb-xl pt-2xl sm:py-2xl">
            <div className="text-text-inverse t-heading-md md:t-heading-lg">
              {description}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
